/**
 * v2 patient-booking feature flag (PMS-derived availability carrying slotId + /v2/bookings).
 * Set REACT_APP_BOOKING_V2=true on staging only. Prod leaves it unset → v1 behaviour unchanged.
 */
export const isBookingV2Enabled = (): boolean => process.env.REACT_APP_BOOKING_V2 === 'true';
